export const sendEvalPromptToKahu = (prompt: string) => {
  window.dispatchEvent(
    new CustomEvent('open-kahu-chat', { detail: { prompt } })
  );
};
